import { Component } from '@angular/core';
import { Logger } from 'src/services/core/logger/logger.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { EditProfileComponent } from '../edit-profile/edit-profile.component';
import { ChangePasswordComponent } from '../change-password/change-password.component';
import { CommonModule } from '@angular/common';

const log = new Logger('Account Settings');
@Component({
  selector: 'app-account-settings',
  templateUrl: './account-settings.component.html',
  styleUrls: ['./account-settings.component.scss'],
  standalone: true,
  imports: [EditProfileComponent, ChangePasswordComponent, CommonModule],
})
export class AccountSettingsComponent {
  exact = { exact: true };
  showChangePassword = false;

  constructor(public activeModal: NgbActiveModal) {}

  toggleShowChangePassword() {
    this.showChangePassword = !this.showChangePassword;
  }
}
